<nz-spin [nzSpinning]='isSpinning'>
  <div class='embla' id='main-carousel'>
    <div class='embla__viewport'>
      <div class='embla__container'>
        <div class='embla__slide' *ngFor='let img of localFileList;let i = index'>
          <div class='embla__slide__inner'>
            <img class='embla__slide__img' *ngIf="img.fileDataType === 'img'" [src]='img.url' (click)='openPreview(i)' />
            <video class='embla__slide__img' *ngIf="img.fileDataType === 'video'" autoplay="autoplay" loop nz-tooltip [nzTooltipTitle]="'点击查看详情'" style='width: 100%;cursor: pointer;background-color: #ddd;' (click)="openPreviewVideo(img)">
              <source [src]="img.url">
              您的浏览器不支持 HTML5 video 标签。
            </video>
          </div>
        </div>
        <div class='embla__slide' *ngFor='let img of tencentFileList;let i = index'>
          <div class='embla__slide__inner'>
            <img class='embla__slide__img' *ngIf="img.fileDataType === 'img'"  [src]='img.url' (click)='openPreview(i + localFileList.length)' />
            <video class='embla__slide__img' *ngIf="img.fileDataType === 'video'" autoplay="autoplay" loop nz-tooltip [nzTooltipTitle]="'点击查看详情'" style='width: 100%;cursor: pointer;background-color: #ddd;' (click)="openPreviewVideo(img)">
              <source [src]="img.url">
              您的浏览器不支持 HTML5 video 标签。
            </video>
          </div>
        </div>
      </div>
    </div>

    <!-- Buttons -->
    <button class='embla__button embla__button--prev' type='button'>
      <svg
        class='embla__button__svg'
        viewBox='137.718 -1.001 366.563 643.999'
      >
        <path
          d='M428.36 12.5c16.67-16.67 43.76-16.67 60.42 0 16.67 16.67 16.67 43.76 0 60.42L241.7 320c148.25 148.24 230.61 230.6 247.08 247.08 16.67 16.66 16.67 43.75 0 60.42-16.67 16.66-43.76 16.67-60.42 0-27.72-27.71-249.45-249.37-277.16-277.08a42.308 42.308 0 0 1-12.48-30.34c0-11.1 4.1-22.05 12.48-30.42C206.63 234.23 400.64 40.21 428.36 12.5z'
        ></path>
      </svg>
    </button>
    <button class='embla__button embla__button--next' type='button'>
      <svg class='embla__button__svg' viewBox='0 0 238.003 238.003'>
        <path
          d='M181.776 107.719L78.705 4.648c-6.198-6.198-16.273-6.198-22.47 0s-6.198 16.273 0 22.47l91.883 91.883-91.883 91.883c-6.198 6.198-6.198 16.273 0 22.47s16.273 6.198 22.47 0l103.071-103.039a15.741 15.741 0 0 0 4.64-11.283c0-4.13-1.526-8.199-4.64-11.313z'
        ></path>
      </svg>
    </button>
  </div>
  <div class='embla embla--thumb' id='thumb-carousel'>
    <div class='embla__viewport'>
      <div class='embla__container embla__container--thumb'>
        <div class='embla__slide embla__slide--thumb' *ngFor='let img of localFileList'>
          <button
            class='embla__slide__inner embla__slide__inner--thumb'
            type='button'
          >
            <img class='embla__slide__thumbnail' *ngIf="img.fileDataType === 'img'" [src]='img.url' />
            <video class='embla__slide__img' *ngIf="img.fileDataType === 'video'" autoplay="autoplay" loop style='width: 100%;cursor: pointer;background-color: #ddd;'>
              <source [src]="img.url">
              您的浏览器不支持 HTML5 video 标签。
            </video>
          </button>
        </div>
        <div class='embla__slide embla__slide--thumb' *ngFor='let img of tencentFileList'>
          <button
            class='embla__slide__inner embla__slide__inner--thumb'
            type='button'
          >
            <img class='embla__slide__thumbnail' *ngIf="img.fileDataType === 'img'" [src]='img.url' />
            <video class='embla__slide__img' *ngIf="img.fileDataType === 'video'" autoplay="autoplay" loop style='width: 100%;cursor: pointer;background-color: #ddd;'>
              <source [src]="img.url">
              您的浏览器不支持 HTML5 video 标签。
            </video>
          </button>
        </div>
      </div>
    </div>
  </div>
  <nz-modal
    nzWidth="760"
    [nzMaskClosable]="false"
    [(nzVisible)]="isShowVideoModal"
    [nzContent]="videoModalContent"
    [nzFooter]="videoModalFooter"
    (nzOnCancel)="closeVideoModal()"
  >
    <ng-template #videoModalContent>
      <div class="video-container">
        <video controls="controls" autoplay="autoplay" loop style="width: 100%;height:680px;">
          <source [src]="videoInfo.url">
          您的浏览器不支持 HTML5 video 标签。
        </video>
      </div>
    </ng-template>
    <ng-template #videoModalFooter>
      <button nz-button class="modal-cancel-btn" (click)="closeVideoModal()">关 闭</button>
    </ng-template>
  </nz-modal>
</nz-spin>
